export const config = {
    appname: 'devapp',
    app_id: '2439493236332961', // App ID
    facebook_app_id: '2439493236332961', // Facebook App ID (Should be the same)
    debug: true, //enable console.log

    // ------------- Development Settings ----------------
    api: 'dev',
    bzbsUrl: 'https://apiservicecenter.buzzebees-dev.com',
    bzbsModuleUrl: 'https://apimodule.buzzebees-dev.com',
    apiShoppingCartUrl: 'https://shoppingcartmodule.buzzebees-dev.com',
    webShoppingCartUrl: 'https://shoppingcartservice.buzzebees-dev.com',
    bzbsBlobUrl: 'https://devstoragebuzzebees.blob.core.windows.net',
    miscUrl: 'https://misc.buzzebees-dev.com',
    // ------------------ End Settings ---------------------

    // --------------------- Recaptcha ---------------------
    recaptchaSiteKey: "6LeSnaAmAAAAAM8nTr70vcd-gBwNnrv06XjpZz-6",
    webApi: '',

    firebase: {
        // apiKey: "",
        // authDomain: "",
        // databaseURL: "",
        // projectId: "",
        // storageBucket: "",
        // messagingSenderId: "",
        // appId: "",
        // measurementId: ""
    },
};
